import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import DeletedUsersTable from '../../pages/features/DeletedUsersTable';
import RejectedApplicationsTable from '../../pages/features/RejectedApplicationsTable';
import { HiTrash, HiExclamationTriangle } from 'react-icons/hi2';

const JunkDashboard = () => {
  const [activeTab, setActiveTab] = useState('rejected-applications');

  const tabs = [
    {
      id: 'rejected-applications',
      label: 'Rejected Applications',
      icon: HiExclamationTriangle,
      component: <RejectedApplicationsTable />,
    },
    {
      id: 'deleted-users',
      label: 'Deleted Users',
      icon: HiTrash,
      component: <DeletedUsersTable />,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-7xl">
        <div className="mb-6 rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200 bg-gray-50">
            <div className="px-4 pt-4 md:px-6 md:pt-6">
              <h1 className="mb-2 text-2xl font-bold text-gray-900 md:text-3xl">
                Archives Management
              </h1>
              <p className="mb-4 text-sm text-gray-600 md:text-base">
                Manage rejected applications and deleted users. Restore or permanently delete items.
              </p>
            </div>
            <nav className="flex flex-wrap gap-2 border-t border-gray-200 px-4 md:gap-0 md:space-x-8 md:px-6">
              {tabs.map(tab => {
                const Icon = tab.icon;
                return (
                  <motion.button
                    key={tab.id}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                      activeTab === tab.id
                        ? 'border-blue-600 text-black'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-black'
                    }`}
                  >
                    <Icon className="h-4 w-4 md:h-5 md:w-5" />
                    <span>{tab.label}</span>
                  </motion.button>
                );
              })}
            </nav>
          </div>

          <div>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
              >
                {tabs.find(tab => tab.id === activeTab)?.component}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JunkDashboard;
